import { createClient } from '@paysera/http-client-common';
import storageService from '%app/js/common/services/storageService';
import UnauthorizedMiddleware from './middleware/unauthorizedMiddleware';
import UndefinedErrorResponseMiddleware from './middleware/undefinedErrorResponseMiddleware';

export { createRequest } from '@paysera/http-client-common';

export default createClient({
    baseURL: '/',
    middleware: [
        new UnauthorizedMiddleware(),
        new UndefinedErrorResponseMiddleware(storageService),
    ],
});
